import { render } from "./PurchaseInvoices.vue?vue&type=template&id=0fd93367&scoped=true"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=js"

import "./PurchaseInvoices.vue?vue&type=style&index=0&id=0fd93367&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd93367"]])

export default __exports__